import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { IRemitance } from "../../models/Remitance";
import { Column } from "primereact/column";
import { format } from "date-fns";
import { Fetch } from "../../shared/Fetch";
import { InvoiceTracking } from "./Table";

interface IProps {
    open: boolean,
    onHide: () => void,
    singleData: InvoiceTracking,
    toast: any
}

export const InvoiceRemitance = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IRemitance>, loading: boolean });
    const dt = useRef<any>(null);

    const received_Date = (rowData?: any) => {
        let date;
        if (rowData?.received_Date) date = format(new Date(rowData?.received_Date), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);

    };

    const loadTableData = async (invoice_No: string) => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("tbl_Remittance", "GET", null, `invoiceNo=${invoice_No}`, props.toast);
        if (response) {
            const data: Array<IRemitance> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }

    useEffect(() => {
        if (props.open && props.singleData.invoiceNo) {
            loadTableData(props.singleData.invoiceNo);
        }
    }, [props.open]);

    return (
        <>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" stripedRows scrollable scrollHeight="65vh"
                value={tableData.tableData}
                emptyMessage="No Branches found."
                header={""}
                loading={tableData.loading}
            >
                <Column field="invoiceNoName" header="Invoice No." sortable />
                <Column field="received_Amount" header="Received Amount" sortable />
                <Column field="deduction" header="Deduction" sortable />
                <Column field="reason" header="Reason" />
                <Column field="received_Date" header="Received Date" body={received_Date} />
                <Column field="followUP" header="Follow Up" />
                <Column field="vendor_InvoiceNo" header="Vendor Invoice No" />
            </DataTable>
        </>
    );
}